import * as React from "react";
interface props {
  className?: string;
}

const SafetySvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // width="70"
    // height="70"
    className={className}
    fill="none"
    viewBox="0 0 70 70"
  >
    <path
      fill="#FF752C"
      d="M32.234 1.8c-.077-.927.613-1.746 1.543-1.779A35 35 0 1 1 14.755 6.45c.76-.538 1.804-.306 2.306.479.5.784.268 1.822-.488 2.365a31.63 31.63 0 1 0 17.484-5.909c-.93.028-1.745-.656-1.823-1.584"
    ></path>
    <path
      fill="#A1A0A0"
      d="M46.25 35.75a.75.75 0 0 0-.75.75V38h-4.19l-1.716-1.72 4.719-4.72a1.5 1.5 0 0 0 0-2.12l-3.533-3.534-1.72-1.716a1.5 1.5 0 0 0-2.121 0L23.274 37.9a.937.937 0 0 0 .663 1.6h3.691l3.311 3.31a1.5 1.5 0 0 0 2.121 0l5.47-5.467 1.72 1.717a1.49 1.49 0 0 0 1.06.44h4.19V41a.75.75 0 1 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75M38 25.25l1.19 1.19L27.628 38h-2.335z"
    ></path>
  </svg>
);

export default SafetySvg;
